import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import { TYPE_ERROR } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';
import { Link } from '@eb/eds-link';

import { AlertChunky } from '@eb/eds-iconography';

import PageHeader from '../../components/PageHeader';

import SplitContainer from '../../connectedComponents/SplitContainer';
import ConnectedEventbriteLoginOptions from '../../connectedComponents/EventbriteLoginOptions';
import ConnectedSocialLoginOptions from '../../connectedComponents/ConnectedSocialLoginOptions';
import ToSModal from '../../connectedComponents/ToSModal';

import {
    PASSWORD_TOKEN_EXPIRED_MESSAGE,
    TOS_SOCIAL_MUST_BE_ACCEPTED,
} from '../../constants/messages';
import { INVALID_RESET_TOKEN, COMPLETE_SIGN_UP_PATH } from '../../constants';
import { TOSMODAL_SOCIAL_DENIED } from '../../constants/analytics';

import './LoginPage.scss';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/LOG_IN_PATH
 */
class LoginPage extends React.Component {
    static propTypes = {
        clearAuthNotification: PropTypes.func,
        handleSignupClick: PropTypes.func,
        usesNewStyles: PropTypes.bool,
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;
        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });
            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;
        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    componentDidMount() {
        const {
            setSignupSecondStep,
            cleanSocialAuthenticationData,
            clearAuthNotification,
            router: {
                location: { query },
            },
        } = this.props;
        if (setSignupSecondStep) {
            setSignupSecondStep(false);
        }

        //Clear notification and social data when page is loaded.
        clearAuthNotification();
        cleanSocialAuthenticationData();

        /*This is needed here because the route is redirected on the server, before we have the
        chance to set state. SO once the component is loaded we can determine if this page was
        redirected to due to an invalid reset password token*/
        if (query[INVALID_RESET_TOKEN]) {
            this._handleShowNotification(PASSWORD_TOKEN_EXPIRED_MESSAGE);
        }
    }

    _onSignupClick = (event) => {
        const { handleSignUpClick } = this.props;

        event?.preventDefault();

        handleSignUpClick?.();
    };
    _handleToSDenied = () => {
        const { cancelToS } = this.props;

        cancelToS({
            actionName: TOSMODAL_SOCIAL_DENIED,
            notificationMessage: TOS_SOCIAL_MUST_BE_ACCEPTED,
        });
    };

    /**
     * Social login functions
     */

    render() {
        const { usesNewStyles, acceptSocialToS } = this.props;
        const pageHeaderProps = {
            headerText: gettext('Log in'),
            usesNewStyles,
        };
        const buttonCTA = gettext('Log in');

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
                header={<PageHeader {...pageHeaderProps} />}
            >
                <>
                    <ConnectedEventbriteLoginOptions
                        buttonCTA={buttonCTA}
                        handleShowNotification={this._handleShowNotification}
                        handleClearNotification={this._handleClearNotification}
                    />
                    <div className="split-container__divider eds-l-pad-bot-8">
                        <div className="split-container__divider-text eds-text-bm eds-text-weight--heavy">
                            {gettext('or')}
                        </div>
                    </div>
                    <div className="eds-l-mar-left-4">
                        <div
                            className="eds-l-pad-bot-5"
                            data-testid="social-login-section"
                        >
                            <ConnectedSocialLoginOptions
                                buttonAppleText={gettext('Sign in with Apple')}
                                buttonFBText={gettext('Sign in with Facebook')}
                                buttonGoogleText={gettext(
                                    'Sign in with Google',
                                )}
                            />
                        </div>

                        <div className="eds-text-color--ui-800 eds-text-weight--heavy eds-l-pad-bot-5">
                            <Link
                                onClick={this._onSignupClick}
                                type="button"
                                data-testid="go-to-signup"
                                to={COMPLETE_SIGN_UP_PATH}
                            >
                                {gettext('Sign up for Eventbrite')}
                            </Link>
                        </div>
                    </div>

                    <ToSModal
                        dataTestId="signup-tos"
                        onAcceptToS={acceptSocialToS}
                        onCancelToS={this._handleToSDenied}
                    />
                </>
            </SplitContainer>
        );
    }
}

export default withMainControls(LoginPage);
